"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var paymentStyles = styles_1.makeStyles(function (theme) { return ({
    subTitle: {
        margin: "0 0 " + theme.spacing(2) + " 0",
        fontWeight: theme.typography.fontWeightBold,
    },
    paragraph: {
        margin: "0 0 " + theme.spacing(2) + " 0",
    },
    paymentButtonWrapper: {
        height: '100px',
        padding: theme.spacing(1) + " 0 0 0",
    },
    saveDealButton: {
        maxWidth: '350px',
        width: '100%',
    },
    visaNetForm: {
        '& button': {
            width: '223px',
            height: '49px',
            margin: 'auto',
            display: 'block',
        },
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
    },
    cardContainer: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            maxWidth: '50px',
            height: 'auto',
            padding: 0,
            transform: 'translate(10px, -35%)',
        },
    },
    cardLogo: {
        maxWidth: '50px',
        height: 'auto',
        padding: 0,
        transform: 'translate(10px, -35%)',
    },
}); }, { name: 'Checkout_Payment' });
exports.default = paymentStyles;
